"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../enums");

var utils_1 = require("../utils");

var TypedObjectBaseConverter_1 = require("./TypedObjectBaseConverter");

var StringVariableBaseConverter =
/** @class */
function (_super) {
  __extends(StringVariableBaseConverter, _super);

  function StringVariableBaseConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  StringVariableBaseConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message));
  };

  StringVariableBaseConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object));
  };

  return StringVariableBaseConverter;
}(TypedObjectBaseConverter_1.TypedObjectBaseConverter);

exports.StringVariableBaseConverter = StringVariableBaseConverter;

var AddStringVariableConverter =
/** @class */
function (_super) {
  __extends(AddStringVariableConverter, _super);

  function AddStringVariableConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddStringVariableConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message), {
      variables: utils_1.withDefault(message.variables, []).map(function (x) {
        return exports.stringVariableConverter.fromMessage(x);
      })
    });
  };

  AddStringVariableConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object), {
      variables: object.variables.map(function (x) {
        return exports.stringVariableConverter.toMessage(x);
      })
    });
  };

  return AddStringVariableConverter;
}(StringVariableBaseConverter);

exports.AddStringVariableConverter = AddStringVariableConverter;

var ConstantStringVariableConverter =
/** @class */
function (_super) {
  __extends(ConstantStringVariableConverter, _super);

  function ConstantStringVariableConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ConstantStringVariableConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message), {
      value: message.value
    });
  };

  ConstantStringVariableConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object), {
      value: object.value
    });
  };

  return ConstantStringVariableConverter;
}(StringVariableBaseConverter);

exports.ConstantStringVariableConverter = ConstantStringVariableConverter;

var MapStringVariableConverter =
/** @class */
function (_super) {
  __extends(MapStringVariableConverter, _super);

  function MapStringVariableConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MapStringVariableConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message), {
      key: message.key,
      defaultValue: utils_1.withDefault(message.defaultValue, "")
    });
  };

  MapStringVariableConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object), {
      key: object.key,
      defaultValue: object.defaultValue
    });
  };

  return MapStringVariableConverter;
}(StringVariableBaseConverter);

exports.MapStringVariableConverter = MapStringVariableConverter;
exports.addStringVariableConverter = new AddStringVariableConverter();
exports.constantStringVariableConverter = new ConstantStringVariableConverter();
exports.mapStringVariableConverter = new MapStringVariableConverter();

var StringVariableConverter =
/** @class */
function () {
  function StringVariableConverter() {}

  StringVariableConverter.prototype.fromMessage = function (message) {
    if (typeof message === "string") {
      return exports.constantStringVariableConverter.fromMessage({
        type: enums_1.StringVariableType.Constant,
        value: message
      });
    }

    switch (message.type) {
      case undefined:
        return exports.constantStringVariableConverter.fromMessage(__assign({
          type: enums_1.StringVariableType.Constant
        }, message));

      case enums_1.StringVariableType.Constant:
        return exports.constantStringVariableConverter.fromMessage(message);

      case enums_1.StringVariableType.Map:
        return exports.mapStringVariableConverter.fromMessage(message);

      case enums_1.StringVariableType.Add:
        return exports.addStringVariableConverter.fromMessage(message);
    }
  };

  StringVariableConverter.prototype.toMessage = function (object) {
    switch (object.type) {
      case enums_1.StringVariableType.Constant:
        return object.value;

      case enums_1.StringVariableType.Map:
        return exports.mapStringVariableConverter.toMessage(object);

      case enums_1.StringVariableType.Add:
        return exports.addStringVariableConverter.toMessage(object);
    }
  };

  return StringVariableConverter;
}();

exports.StringVariableConverter = StringVariableConverter;
exports.stringVariableConverter = new StringVariableConverter();